import { supabase } from '@/lib/supabase'

// Marketing-site email actions, proxied through the public `site-email` edge
// function so the Resend key and the Turnstile secret stay server-side. Both
// calls carry a Turnstile token; the function rejects anything without one.

// Site key for the Turnstile widget on the public forms. Shared with the
// signup flow (see Register.jsx). Absent in an environment means the widget
// can't render and the edge function will reject the submission — the forms
// surface that rather than silently failing.
export const TURNSTILE_SITE_KEY = import.meta.env.VITE_TURNSTILE_SITE_KEY || ''

// The edge function fails closed without a captcha, so a missing site key
// means "can't submit", not "captcha optional" — forms check this before
// demanding a token so they don't block on a widget that never renders.
export const isTurnstileConfigured = () => !!TURNSTILE_SITE_KEY

async function call(body) {
  const { data, error } = await supabase.functions.invoke('site-email', { body })
  if (error) {
    // Supabase wraps non-2xx responses; surface the function's own message.
    let parsed = null
    try {
      parsed = await error.context?.json()
    } catch { /* not JSON */ }
    throw new Error(parsed?.error || error.message || 'Request failed')
  }
  if (data?.error) throw new Error(data.error)
  return data
}

// Homepage "Get early access" capture: mails the address a confirmation link.
// Nothing is added to the list until that link is used.
export const subscribeToUpdates = (email, captchaToken) =>
  call({ action: 'subscribe', email, captchaToken })

// /confirm-subscription: the button behind the emailed link. Adds the address
// to the list, then sends the welcome and notifies info@getdub.com.
export const confirmSubscription = (token) =>
  call({ action: 'confirm', token })

// /contact form: delivers the message to info@getdub.com with Reply-To set to
// the sender. fields: { name, email, subject, message }
export const sendContactMessage = (fields, captchaToken) =>
  call({ action: 'contact', ...fields, captchaToken })
